import api from './api'

const CHECKLISTS_URL = '/checklists'

export default {
  view: function (id) {
    var url = CHECKLISTS_URL
    return api.newRequest('get', url)
  },
  update: function (payload) {
    var url = CHECKLISTS_URL + '/' + payload.id
    return api.newRequest('patch', url, payload)
  }
}
